(function(){
  var CLEAN_BLACK='https://cdn.shopify.com/s/files/1/1085/2909/0885/files/scalpzen-clean-black-hero.jpg?v=1787334183';
  var COLORS={
    Black:{src:CLEAN_BLACK,alt:'ScalpZen™ black scalp massager clean product photo'},
    Blue:{src:'https://cdn.shopify.com/s/files/1/1085/2909/0885/files/3064930890145.jpg?v=1786478937',alt:'ScalpZen™ blue scalp massager'},
    Pink:{src:'https://cdn.shopify.com/s/files/1/1085/2909/0885/files/327309141885.jpg?v=1786478937',alt:'ScalpZen™ pink scalp massager'},
    Purple:{src:'https://cdn.shopify.com/s/files/1/1085/2909/0885/files/2192662445258.jpg?v=1786478938',alt:'ScalpZen™ purple scalp massager'}
  };
  function initHome(){
    if(document.body.classList.contains('sz-body')){
      var split=document.querySelector('.sz-split-media img');
      if(split){split.src=CLEAN_BLACK;split.removeAttribute('srcset');split.alt=COLORS.Black.alt;}
    }
  }
  function initProduct(){
    var main=document.getElementById('ScalpZenMainProductImage');
    var media=document.querySelector('.sz-main-media');
    if(!main||!media||media.dataset.szEnhanced==='1') return;
    media.dataset.szEnhanced='1';
    var names=['Black','Blue','Pink','Purple'];
    var index=0;
    var arrows=document.createDocumentFragment();
    var prev=document.createElement('button');prev.type='button';prev.className='sz-carousel-arrow sz-carousel-prev';prev.setAttribute('aria-label','Previous product image');prev.innerHTML='‹';
    var next=document.createElement('button');next.type='button';next.className='sz-carousel-arrow sz-carousel-next';next.setAttribute('aria-label','Next product image');next.innerHTML='›';
    arrows.appendChild(prev);arrows.appendChild(next);media.appendChild(arrows);
    var dots=document.createElement('div');dots.className='sz-carousel-dots';dots.setAttribute('aria-label','Product image navigation');
    names.forEach(function(name,i){var dot=document.createElement('button');dot.type='button';dot.className='sz-carousel-dot'+(i===0?' active':'');dot.setAttribute('aria-label','View '+name);dot.dataset.index=String(i);dot.addEventListener('click',function(){setSlide(i);});dots.appendChild(dot);});
    media.appendChild(dots);
    var dotEls=Array.from(dots.children);
    function setSlide(i){
      if(i<0)i=names.length-1;if(i>=names.length)i=0;index=i;
      var item=COLORS[names[index]];main.style.opacity='0.15';
      window.setTimeout(function(){main.src=item.src;main.removeAttribute('srcset');main.alt=item.alt;main.style.opacity='1';},70);
      dotEls.forEach(function(d,j){d.classList.toggle('active',j===index);});
    }
    prev.addEventListener('click',function(){setSlide(index-1);});
    next.addEventListener('click',function(){setSlide(index+1);});
    var startX=null;
    media.addEventListener('touchstart',function(e){startX=e.touches[0].clientX;},{passive:true});
    media.addEventListener('touchend',function(e){if(startX===null)return;var dx=e.changedTouches[0].clientX-startX;startX=null;if(Math.abs(dx)>42)setSlide(index+(dx<0?1:-1));},{passive:true});
    document.querySelectorAll('.sz-variant-swatch').forEach(function(btn){
      btn.addEventListener('click',function(){
        var color=btn.dataset.color;
        var i=names.indexOf(color);
        if(i>-1) window.setTimeout(function(){setSlide(i);},0);
      });
    });
    setSlide(0);
  }
  function lockProductPrice(){
    var price=document.querySelector('.sz-live-price[data-live-price]');
    if(!price) return;
    function enforce(){
      if(price.textContent.trim()!=='21,90 €') price.textContent='21,90 €';
    }
    enforce();
    if(price.dataset.szPriceLock==='1') return;
    price.dataset.szPriceLock='1';
    var observer=new MutationObserver(enforce);
    observer.observe(price,{childList:true,characterData:true,subtree:true});
  }
  function init(){initHome();initProduct();lockProductPrice();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();